// Mutation hook - test polaczenia SMTP dla zapisanej skrzynki.
// POST /api/ui/sales-crm/mailbox/test-smtp
// Brak request body. Backend uzywa danych z zapisanej skrzynki zalogowanego handlowca.

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { ITestConnectionResponse } from 'api/types/mailbox';

const testSmtpConnection = (): Promise<ITestConnectionResponse> =>
  axios.post('/sales-crm/mailbox/test-smtp');

export const useTestSmtpConnection = (
  options?: UseMutationOptions<ITestConnectionResponse, IError, void>
) =>
  useMutation<ITestConnectionResponse, IError, void>(testSmtpConnection, options);
